<div class="out" #out>
  <input kzInput class="fl" cpColorMode="color" [cpPresetColors]="presets" cpDialogDisplay="inline" cpPositionOffset="10" [cpToggle]="true" [colorPicker]="color" [cpAddColorButton]="false" (colorPickerChange)="setColor($event)" [style.background]="color"
    cpPosition="bottom" />
</div>
